import { createContext, type ReactNode, useContext } from 'react'
import type { SubmitButtonText } from './Form/useFormLogic'

type FormLocalizationProviderContextProps = {
  submitButton: Record<SubmitButtonText, string>
  successMessage: Record<SubmitButtonText, string>
  modalForm: {
    cancelButton: string
  }
  uploadInput: {
    text: string
  }
  unsavedChanges: (count: number) => string
  leaveUnsavedChanges: string
}

type FormLocalizationProviderProps = {
  children: ReactNode
} & FormLocalizationProviderContextProps

export const FormLocalizationContext = createContext<FormLocalizationProviderContextProps>({
  submitButton: {
    save: 'Save',
    send: 'Send',
    add: 'Add',
  },
  successMessage: {
    save: 'Successfully saved',
    send: 'Successfully sent',
    add: 'Successfully added',
  },
  modalForm: {
    cancelButton: 'Cancel',
  },
  uploadInput: {
    text: 'Click or drag file to this area to upload',
  },
  unsavedChanges: (count: number) => `You have ${count} unsaved changes`,
  leaveUnsavedChanges: 'You have unsaved changes. Are you sure you want to leave?',
})

export const FormLocalizationProvider = ({ children, ...props }: FormLocalizationProviderProps) => {
  return (
    <FormLocalizationContext.Provider value={props}>{children}</FormLocalizationContext.Provider>
  )
}

export const useFormLocalization = () => useContext(FormLocalizationContext)
